import { inject, Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';

@Injectable({
  providedIn: 'root',
})
export class ToastService {
  private readonly messageService = inject(MessageService);
  private readonly defaultLife = 10000;

  showError(body: string, life?: number): void {
    this.messageService.add({
      severity: 'error',
      summary: 'Error',
      detail: body,
      life: life ?? this.defaultLife,
    });
  }

  showInfo(body: string, life?: number): void {
    this.messageService.add({
      severity: 'info',
      summary: 'Info',
      detail: body,
      life: life ?? this.defaultLife,
    });
  }

  showSuccess(body: string, life?: number): void {
    this.messageService.add({
      severity: 'success',
      summary: 'Success',
      detail: body,
      life: life ?? 5000,
    });
  }
}
